import React, { useState } from 'react';
import { Box, Typography, Button, Grid, styled, Dialog } from '@mui/material';
import { imageList } from '../../../assets/images';
import CustomButton from '../../../components/common/button/CustomButton';
import SentimentVeryDissatisfied from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfied from '@mui/icons-material/SentimentDissatisfied';
import SentimentNeutral from '@mui/icons-material/SentimentNeutral';
import SentimentSatisfied from '@mui/icons-material/SentimentSatisfied';
import SentimentVerySatisfied from '@mui/icons-material/SentimentVerySatisfied';

interface ImageList {
    [key: string]: string;
}

// Styled components for consistent design
const StyledContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    backgroundColor: '#fff',
    borderRadius: 8,
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    maxWidth: 500,
    margin: 'auto',
}));

const Header = styled(Typography)(({ theme }) => ({
    fontSize: '2.5rem',
    marginBottom: theme.spacing(1),
    textAlign: 'center',
    lineHeight: 1
}));

const SubHeader = styled(Typography)(({ theme }) => ({
    fontSize: '1rem',
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    color: '#555',
}));

const EmojiContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
}));

const EmojiButton = styled(Button)(({ theme }) => ({
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: theme.palette.text.primary,
    '&:hover': {
        transform: 'scale(1.2)',
        transition: 'transform 0.3s',
    },
}));

const FeedbackDialog = () => {
    const [open, setOpen] = useState(false)

    return (
        <Dialog
            open={open}
        >
            <StyledContainer>
                <img
                    src={(imageList as ImageList)["logo"]}
                    alt="Logo"
                    style={{
                        verticalAlign: "middle",
                        borderRadius: '50%',
                        objectFit: 'cover',
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                        marginBottom: '20px'
                    }}
                />
                <Header>How would you rate your experience?</Header>
                <EmojiContainer>
                    <EmojiButton><SentimentVeryDissatisfied sx={{ fontSize: 50 }} color="error" /></EmojiButton>
                    <EmojiButton ><SentimentDissatisfied sx={{ fontSize: 50 }} color="warning" /></EmojiButton>
                    <EmojiButton ><SentimentNeutral sx={{ fontSize: 50 }} color="warning" /></EmojiButton>
                    <EmojiButton><SentimentSatisfied sx={{ fontSize: 50 }} color="success" /></EmojiButton>
                    <EmojiButton><SentimentVerySatisfied sx={{ fontSize: 50 }} color="success" /></EmojiButton>
                </EmojiContainer>
                <SubHeader sx={{ marginBottom: 1 }}>This will help us improve.</SubHeader>
                <textarea
                    placeholder="Your feedback here..."
                    style={{
                        width: '100%',
                        height: '80px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        padding: '10px',
                        marginBottom: '20px',
                        fontSize: '1rem',
                    }}
                />
                <CustomButton title='Submit' onClick={()=>setOpen(false)} />
            </StyledContainer>
        </Dialog>
    )
}

export default FeedbackDialog